<template>
  <div class="modal offer-modal">
    <div class="overlay" @click="$emit('closeOrderDetailsModal')"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$emit('closeOrderDetailsModal')"
        src="./../assets/close.svg"
      />
      <div class="container">
        <form @submit.prevent>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">Order #{{ orderToView.id }}</div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="title">Skin name</div>
                    <div class="desc">{{ orderToView.title }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Quality</div>
                    <div class="desc">{{ orderToView.item_quality || 'N/A' }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Item count</div>
                    <div class="desc">{{ orderToView.count || 1 }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Price</div>
                    <div class="desc">{{ orderToView.sum }} {{ orderToView.currency }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderDetailsModal",
  props: ["orderToView"],
  methods: {
    getOrderItemNames(order) {
      if (order.items && order.items.length > 0) {
        return order.items.map(item => item.name || item.title).join(", ");
      }
      return order.item_name || order.title || "N/A";
    },
    getItemCount(order) {
      if (order.items && order.items.length > 0) {
        return order.items.reduce((total, item) => total + (item.quantity || 1), 0);
      }
      return order.quantity || 1;
    },
  },
};
</script>

<style scoped></style>